import React,{ useState,useEffect, useRef} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import {connect} from 'react-redux';
import swal from 'sweetalert';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Autocomplete from '@material-ui/lab/Autocomplete';
import MUIDataTable from "mui-datatables";
import {API_URL} from '../../config.js';
import {BrowserRouter as Router,Route,Link} from 'react-router-dom'
import axios from 'axios';
import SaveIcon from '@material-ui/icons/Save';
import Button from '@material-ui/core/Button';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TextareaAutosize from '@material-ui/core/TextareaAutosize';
import { Form, Radio } from "semantic-ui-react";
import { useHistory } from "react-router-dom";


import { Modal } from 'react-responsive-modal';
import "react-responsive-modal/styles.css";



import EditIcon from '@material-ui/icons/Edit';


import DeleteIcon from '@material-ui/icons/Delete';
import RemoveCircleIcon from '@material-ui/icons/RemoveCircle';


import Stack from '@mui/material/Stack';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import DesktopDatePicker from '@mui/lab/DesktopDatePicker';


import {currentRouteSet} from '../../actions/actions';

import {pathSpliter,checkAuthBranchWare,dateTimeFormat,currentDateTime, dateFormat} from '../../lib/functions'
import moment from 'moment';


import _ from 'lodash';
import commaNumber from 'comma-number';
let format = commaNumber.bindWith(',', '.')

const GroupManage = ({location,currentRouteSet,currentRoute,authInfo})=>{
    const classes = useStyles();
    const history = useHistory();

  
      // Initial values Set - Start
      let [replace_id,replace_id_set] = useState(0)
      let [given_ind_id,given_ind_id_set] = useState(null);
      let [return_ind_id,return_ind_id_set] = useState(null);
      let [action,action_set] = useState('create');
      let [voucher_no,voucher_no_set] = useState('');
      let [is_warehouse,is_warehouse_set] = useState('')
      let [currency,currency_set] = useState('')
      let [is_serial,is_serial_set] = useState('no');
  
      let [per_return_conversion,per_return_conversion_set] = useState(0)
      let [per_given_conversion,per_given_conversion_set] = useState(0)

      const [serialModal,serialModalSet] = useState(false)
      const [serial_number,serial_number_set] = useState('')
  
      let [serials,serialsSet] = useState([]);
      let [returnSerials,returnSerialsSet] = useState([]);
      let [givenSerials,givenSerialsSet] = useState([]);
      let [selectedGivenSerials,selectedGivenSerialsSet] = useState([]);
      
      let [items,itemsSet] = useState([]);
      let [customers,customersSet] = useState([]);
      let [rows,rowsSet] = useState([]);
      let [itemGivenCart,itemGivenCartSet] = useState([])
      let [itemReturnCart,itemReturnCartSet] = useState([])
      let [warehouses,warehouses_set] = useState([])
  
      
      let [loadingSave,loadingSaveSet] = useState(false)
  
      let [previous_due,previous_due_set] = useState(0);

  
      let [selectedItemWarehouse,selectedItemWarehouseSet] = useState(null);
      let [selectedReturnWarehouse,selectedReturnWarehouseSet] = useState(null);
      let [selectedItem,selectedItemSet] = useState(null);
      let [selectedReturn,selectedReturnSet] = useState(null);

      let [rawItemInfo,rawItemInfoSet] = useState({
        current_qty : 0,
        display_qty : '',
        rate : 0,
      })
  
  

      const [customer_name, customer_name_set] = useState("");
      const [acc_name, acc_name_set] = useState("General Customer");
      const [contact_no, contact_no_set] = useState("");
      const [institution_name, institution_name_set] = useState("");
      const [address, address_set] = useState("");
  
      const [created_date, created_date_set] = useState(currentDateTime);
  
      
  
      let [orderId,orderIdSet] = useState(0);


      let [item_qty,item_qty_set] = useState('');
      let [item_rate,item_rate_set] = useState('');
      let [item_total,item_total_set] = useState(0);
      let [retail_qty,retail_qty_set] = useState(0);
      let [given_qty,given_qty_set] = useState(0);
      let [given_rate,given_rate_set] = useState(0);
      let [conversion,conversion_set] = useState(0)
      let [item_percentage,item_percentage_set] = useState(0)
      


      let [labour_cost,labour_cost_set] = useState(0)
      let [others_cost,others_cost_set] = useState(0)
      let [total_cost,total_cost_set] = useState(0)
  
  
      let [return_item_qty,return_item_qty_set] = useState('');
      let [return_item_rate,return_item_rate_set] = useState('');
      let [return_item_total,return_item_total_set] = useState(0);
      let [return_retail_qty,return_retail_qty_set] = useState(0);
      let [return_qty,return_qty_set] = useState(0);
      let [return_rate,return_rate_set] = useState(0);
      let [return_conversion,return_conversion_set] = useState(0)
      let [availableSerials,availableSerialsSet] = useState([]);

  
      let [narration,narration_set] = useState('');
  

      const [item_name, item_name_set] = useState("");
      const [return_name, return_name_set] = useState("");
      const [return_serial_number, return_serial_number_set] = useState("");


      let [selectedCustomer,selectedCustomerSet] = useState(null);

      let [returnUnits,returnUnitsSet] = useState([]);
      let [givenUnits,givenUnitsSet] = useState([]);
      let [selectedReturnUnit,selectedReturnUnitSet] =  useState(null);
      let [selectedGivenUnit,selectedGivenUnitSet] =  useState(null);

      useEffect(()=>{
        getCustomers()
        },[customer_name])

       

        
  const getCustomers = async() => {
    await axios.post(`${API_URL}/api/get-accounts-by-search`,{query:customer_name.trim(),type:'debitor'},{headers:{'auth-token':authInfo.token}}).then(res=>{
    //  let newCustomer = {
    //    display_text:'New Customer',
    //    acc_name:'New Customer',
    //    acc_id:'N',
    //    contact_no:'',
    //    address:'',
    //    party_type: 'retailer'
    //  } 

    //  let generalCustomer = {
    //    display_text:'General Customer',
    //    acc_name:'General Customer',
    //    acc_id:'G',
    //    contact_no:'',
    //    address:'',
    //    party_type: 'general'
    //  } 
      let newArray = res.data
    //  newArray.push(generalCustomer)
    //  newArray.push(newCustomer)
      customersSet(newArray)

     


   })
};
    useEffect(()=>{
      if(selectedCustomer != null &&  selectedCustomer.acc_id == 'G'){


        previous_due_set(0)

      }


      if(selectedCustomer != null &&  selectedCustomer.acc_id != 'G' && selectedCustomer.acc_id != 'N'){
        axios.post(`${API_URL}/api/get-sundry-debitor-balance`,{customerId:selectedCustomer != null ? selectedCustomer.acc_id : 0},{headers:{'auth-token':authInfo.token}}).then( (res)=>{
          if(res.data.accounts.length ==0){
            previous_due_set(0)
            return false
          } 
          previous_due_set(res.data.accounts[0].balance)
         })
      }



    },[selectedCustomer])


// For Consume item

      useEffect(()=>{
        if(selectedReturn != null){
          returnUnitsSet(selectedReturn.units)

          if(return_ind_id == null){
            selectedReturnUnitSet(selectedReturn.units[0])

          }
        }else{
          returnUnitsSet([])
          selectedReturnUnitSet(null)
        }
      },[selectedReturn])

      useEffect(()=>{
        if(selectedReturn != null && selectedReturnUnit == null  ){
           selectedReturnUnitSet(selectedReturn.units[0])

          
        }

        if(selectedReturnUnit != null){
          per_return_conversion_set(selectedReturnUnit.conversion)
        }
      },[selectedReturnUnit])
  


// For Production item
      useEffect(()=>{
        if(selectedItem != null){
          givenUnitsSet(selectedItem.units)

          if(given_ind_id == null){
            selectedGivenUnitSet(selectedItem.units[0])

          }
        }else{
        givenUnitsSet([])
          selectedGivenUnitSet(null)
        }
      },[selectedItem])

      useEffect(()=>{
        if(selectedItem != null && selectedGivenUnit == null  ){
          selectedGivenUnitSet(selectedItem.units[0])

          
        }

        if(selectedGivenUnit != null){
          per_given_conversion_set(selectedGivenUnit.conversion)
        }
      },[selectedGivenUnit])
  

      

      // Init value End

 // API Requests - Start
  useEffect(()=>{
    replace_id_set(pathSpliter(location.pathname,3) != undefined?parseFloat( pathSpliter(location.pathname,3)):0);
    currentRouteSet(pathSpliter(location.pathname,1));

    if(pathSpliter(location.pathname,3) != undefined?parseFloat( pathSpliter(location.pathname,3)):0 != 0 ){
      action_set('update')
    }
   
    is_warehouse_set(authInfo.is_warehouse)
    currency_set(authInfo.currency)
    if(authInfo.is_warehouse == 'yes'){
      getWarehouses()
    }
 

    getManuInv()
    item_ref.current.focus()
    if(pathSpliter(location.pathname,3) != undefined?parseFloat( pathSpliter(location.pathname,3)):0 != 0){
      loadingSaveSet(true)
      getPurchaseRecordWithDetail();
    }
  },[]);

  useEffect(()=>{
    getItems()
  },[item_name])

  useEffect(()=>{
    getRowItems()
  },[return_name])





  let getPurchaseRecordWithDetail = async ()=>{
      let url = `/api/get-replace-record-with-details`
      let para = {replace_id:pathSpliter(location.pathname,3) != undefined?parseFloat( pathSpliter(location.pathname,3)):0}
      // if(pathSpliter(location.pathname,2) == 'order-to-purchase'){
      //   url = `/api/get-manufacturing-order-record-with-details`
      //   para = {given_o_id:pathSpliter(location.pathname,3) != undefined?parseFloat( pathSpliter(location.pathname,3)):0}
      // }
    await axios.post(`${API_URL}${url}`,para,{headers:{'auth-token':authInfo.token}}).then(res=>{
      let data = res.data[0];
      let dataMIDetails = res.data[0].miDetails;
      let dataMCIDetails = res.data[0].mciDetails;
      // if(pathSpliter(location.pathname,2) != 'order-to-manufacturing'){
         voucher_no_set(data.voucher_no);
         orderIdSet(data.order_id)

      // }else{
      //   orderIdSet(pathSpliter(location.pathname,3))
      // }
      



         
      selectedCustomerSet({acc_id: data.acc_id,acc_name: data.acc_name,display_text: data.acc_name,institution_name: data.institution_name,
        contact_no: data.contact_no,address: data.address})
 acc_name_set(data.acc_name)
 institution_name_set(data.institution_name)
 contact_no_set(data.contact_no)
 address_set(data.address)
      
       created_date_set(data.created_date);
       narration_set(data.narration);
   
       is_serial_set(data.is_serial)

       labour_cost_set(data.labour_cost)
       others_cost_set(data.others_cost)
    

       // Manufacturing Detail Data to Product Cart - Start
      let itemGivenCartData =  dataMIDetails.map((item)=>{ 
        let serials = []
        
        serials = item.serials.split(',');
        if(item.is_serial == 'yes' ){
          serials = serials.map((slNo)=>{
            return {serial_number : slNo}
          })
        }else{
          serials = []
        }


          let updateItemn = {
            warehouse_id : item.warehouse_id,
            warehouse_name : item.warehouse_name,
            item_id : item.item_id,
            item_name : item.item_name,
            display_text : item.display_text,
            is_serial: item.is_serial,
            item_qty:item.item_qty,
            item_rate:item.item_rate,
            item_percentage:item.item_percentage,
           
            serials,
            item_total:item.item_total,
            retail_qty:item.retail_qty,
            given_qty:item.given_qty,
            given_rate:item.given_rate,
            qty_display: item.item_qty +' '+ item.unit_symbol + (item.conversion >1 ? ', '+ item.retail_qty +' ' +item.base_unit_name:''),
            unit_symbol: item.unit_symbol,
            base_unit_name: item.base_unit_name,
            unit_name: item.unit_name,
            conversion: item.conversion,


            units: item.units,
            per_symbol : item.unit_symbol,
            per_conversion : item.per_conversion,
            per_unit_id : item.per_unit_id,
            per_unit_symbol: item.per_unit_symbol 

          }


          return updateItemn;
        });


        itemGivenCartSet(itemGivenCartData);

        // Manufacturing Detail Data to Product Cart - End




          // Consume Detail Data to Product Cart - Start
      let  itemReturnCartData =  dataMCIDetails.map((item)=>{ 
        let serials = []
        
        serials = item.serials.split(',');
        if(item.is_serial == 'yes' ){
          serials = serials.map((slNo)=>{
            return {serial_number : slNo}
          })
        }else{
          serials = []
        }

          let updateItem = {
            warehouse_id : item.warehouse_id,
            warehouse_name : item.warehouse_name,
            item_id : item.item_id,
            item_name : item.item_name,
            display_text : item.display_text,
            is_serial: item.is_serial,
            return_item_qty:item.return_item_qty,
            return_item_rate:item.return_item_rate,
           
            serials,
            return_item_total:item.return_item_total,
            return_retail_qty:item.return_retail_qty,
            return_qty:item.return_qty,
            return_rate:item.return_rate,
            qty_display: item.return_item_qty +' '+ item.unit_symbol + (item.conversion >1 ? ', '+ item.return_retail_qty +' ' +item.base_unit_name:''),
            unit_symbol: item.unit_symbol,
            base_unit_name: item.base_unit_name,
            unit_name: item.unit_name,
            return_conversion: item.conversion,

            units: item.units,
            per_symbol : item.unit_symbol,
            per_conversion : item.per_conversion,
            per_unit_id : item.per_unit_id,
            per_unit_symbol: item.per_unit_symbol
          }
          return updateItem;
        });
        itemReturnCartSet(itemReturnCartData);

        // Consume Detail Data to Product Cart - End



        loadingSaveSet(false)
    });
  }

 


        let getManuInv = async ()=>{
          await  axios.get(`${API_URL}/api/get-replace-voucher-no`,{headers:{'auth-token':authInfo.token}}).then(res=>{
            voucher_no_set(res.data)
      
          })
        }

 




 

  const getWarehouses = async() => {
      await axios.post(`${API_URL}/api/get-warehouses`,{"select-type":"active"},{headers:{'auth-token':authInfo.token}}).then(res=>{
         warehouses_set(res.data.message)
      })
  };

  const getItems = async() => {
      await axios.post(`${API_URL}/api/get-items-by-search`,{query:item_name.trim(),search:true},{headers:{'auth-token':authInfo.token}}).then(res=>{
         itemsSet(res.data)
      })
  };

  const getRowItems = async() => {
    await axios.post(`${API_URL}/api/get-items-by-search`,{query:return_name.trim(),search:true},{headers:{'auth-token':authInfo.token}}).then(res=>{
       rowsSet(res.data)
    })
};


   // API Requests - End

 


  

    // Initial values Set - Start


    // Input Refs - Start
    let warehouse_ref = useRef(null)
    let item_ref = useRef(null)
    let item_qty_ref = useRef(null)
    let item_rate_ref = useRef(null)
    let retail_qty_ref = useRef(null)


    let return_warehouse_ref = useRef(null)
    let return_ref = useRef(null)
    let return_item_qty_ref = useRef(null)
    let return_item_rate_ref = useRef(null)
    let return_retail_qty_ref = useRef(null)
    let return_item_ref = useRef(null)

    
   
    
    // Input Refs - End


    // Input Calculations - Start

    /// for Item 
    useEffect(()=>{
      let total_qty = item_qty * conversion;
      total_qty += parseFloat(retail_qty)

        let cartTotal =  itemGivenCart.reduce((prev,curr)=>{
          return prev+parseFloat(curr.item_total)
         },0)

        //  let cost = total_cost - cartTotal

       // Parcentage

       let totalQty =  itemGivenCart.reduce((prev,curr)=>{
        return prev+parseFloat(curr.item_qty)
      },0)

      //  let calPercentage = itemGivenCart.length != 0 ? (100 / totalQty ) : (100 / 1 )
      // let rateOfCosting = ((total_cost *  calPercentage)/100)/total_qty;

      let rateOfCosting = total_cost / (totalQty > 0 ? totalQty : 1)
      // End

      //             let perQtyRate = per_given_conversion > 1? rateOfCosting / conversion : (rateOfCosting * conversion) / conversion;

      let perQtyRate = per_given_conversion > 1? rateOfCosting  : (rateOfCosting * conversion) / conversion;
      item_rate_set(parseFloat(rateOfCosting * conversion).toFixed(2))
      given_rate_set(perQtyRate);
      given_qty_set(total_qty);
     
  let  total = parseFloat((total_qty * perQtyRate) ).toFixed(2);

  item_total_set(parseFloat(total).toFixed(2));


},[selectedItem,selectedGivenUnit,item_qty,item_rate,retail_qty,item_percentage])



  

  let callAllProductionItem = (tempCart)=>{
    let newArr   =  tempCart.map((item,ind)=>{


      let total_qty = item.item_qty * item.conversion;
      total_qty += parseFloat(item.retail_qty)

     let totalQty =  tempCart.reduce((prev,curr)=>{
        return prev+parseFloat(curr.item_qty)
      },0)
       // Parcentage
      //  let calPercentage = tempCart.length != 0 ? (100 / totalQty ) : (100 / 1 )

      //  let rateOfCosting = ((total_cost * calPercentage )/100)/total_qty;
      let rateOfCosting = total_cost / (totalQty > 0 ? totalQty : 1)
       // End

       let perQtyRate = per_given_conversion > 1? rateOfCosting  : (rateOfCosting * item.conversion) / item.conversion;


        item.given_rate = perQtyRate;

        item.item_rate = parseFloat(rateOfCosting * item.conversion).toFixed(2);
        item.item_total = parseFloat((total_qty * perQtyRate) * item.conversion).toFixed(2);


        return item;
      });

        itemGivenCartSet(newArr);  
  }

    useEffect(()=>{
      if(itemGivenCart.length != 0){
        callAllProductionItem(itemGivenCart);

      }
      
    },[total_cost]);

    



    useEffect(()=>{
      
      // let percentageOfRate = ((100 * (item_qty * rateOfCosting))/total_cost)

      // console.log(rateOfCosting,percentageOfRate,per)


      // item_percentage_set(percentageOfRate)
    },[item_percentage])


  
    useEffect(()=>{
    
     let subTotal =  itemGivenCart.reduce((prev,curr)=>{
        return prev+parseFloat(curr.item_total)
      },0);


        let checkIsSerial =   itemGivenCart.findIndex((ele)=>{
          if(ele.is_serial=='yes'){ 
            return true 
          }else{
            return false
          }
          }); 
      
          if(checkIsSerial>-1){
            is_serial_set('yes')
          }else{
            is_serial_set('no')
          }

    },[itemGivenCart]);


 /// End 


// For Rows 


useEffect(()=>{
  let return_total_qty = return_item_qty * return_conversion;
  return_total_qty += parseFloat(return_retail_qty)

  let perQtyRate = per_return_conversion > 1? return_item_rate / return_conversion : (return_item_rate * return_conversion) / return_conversion;


      return_rate_set(perQtyRate);
      return_qty_set(return_total_qty);

      console.log(return_conversion)
 
let  total = parseFloat(return_total_qty * perQtyRate).toFixed(2);

return_item_total_set(parseFloat(total).toFixed(2))


},[selectedReturn,selectedReturnUnit,return_item_qty,return_item_rate,return_retail_qty]) 

useEffect(()=>{
  if(selectedReturn != null){
  axios.post(`${API_URL}/api/get-current-stock`,{itemId:selectedReturn.item_id,
    warehouseId : selectedReturnWarehouse != null ? selectedReturnWarehouse.warehouse_id : 0
  },{headers:{'auth-token':authInfo.token}}).then((res)=>{
   

    rawItemInfoSet({
      current_qty : res.data[0].current_qty,
      rate : res.data[0].average_rate,
      display_qty : res.data[0].display_qty
    })



    return_item_rate_set(res.data[0].average_rate * res.data[0].conversion)
    
  });
  }
},[selectedReturn,selectedReturnWarehouse])





useEffect(()=>{

let subTotal =  itemReturnCart.reduce((prev,curr)=>{
return prev+parseFloat(curr.return_item_total)
},0);


let checkIsSerial =   itemReturnCart.findIndex((ele)=>{
if(ele.is_serial=='yes'){ 
  return true 
}else{
  return false
}
}); 

if(checkIsSerial>-1){
  is_serial_set('yes')
}else{
  is_serial_set('no')
}

},[itemReturnCart]);



// end


    // Input Calculations - End

    // Methods  -  start
  

       // Data Save Method
      
    const savePurchaseOrder = async ()=>{

      if(selectedCustomer == null){
        swal({
          title:`Select Customer!`,
          icon:'warning'
        })
        return false
      }

          if(itemGivenCart.length == 0){
            swal({
              title:`Given cart is Empty !`,
              icon:'warning'
            })
            return false
          }
          
          if(itemReturnCart.length == 0){
            swal({
              title:`Return cart is Empty !`,
              icon:'warning'
            })
            return false
          }else{
           
            let purchaseOrderData = {
               givenCart:itemGivenCart,
                  returnCart:itemReturnCart,
              
                masterData:{

                  voucher_no,
                  customer_id : selectedCustomer.acc_id,
                  is_serial,
                  created_date,
                  narration,

                  labour_cost,
                  others_cost,
                  total_cost,


                  replace_id,
                  orderId: orderId==''?0:orderId,
                 
                
                   
                }
            }

            

        let url = `/api/create-replace`
        if(pathSpliter(location.pathname,3) != undefined ){
            url = `/api/update-replace`
        }
         loadingSaveSet(true) 
         await axios.post(`${API_URL}${url}`,purchaseOrderData,{headers:{'auth-token':authInfo.token}}).then(res=>{
          loadingSaveSet(false)

          if(res.data.error){
            swal({
              title: `${res.data.message}`,
              icon:'warning'
            })
            return false;
          }
          if(!res.data.error){
            swal({title:`${res.data.message}. Do you want to view invoice?`,icon:'success',buttons:true}).then(confirm=>{
              if(confirm){
                history.push(`/sales/quick-replace-voucher/${res.data.replace_id}`)
               
              }else{
                window.location.reload()
              }
            })
          }

          

         })


          }

            
          
          
    }


      // Item cart methods - Start

  const addTOCart = ()=>{

    if(selectedItem.item_id == 0){
      swal({
        title:`Select Item`,
        icon:'warning'
      });
      item_ref.current.focus()
      return false
    }

    if(selectedItem.is_serial == 'yes' && action == 'update' && given_ind_id == null){
      swal({
        title:`Serial Item can't add in Update. You can create new Invoice!`,
        icon:'warning'
      })
      return false
    }
    
    if(is_warehouse == 'yes' && selectedItemWarehouse == null){
      swal({
        title:`Select Warehouse`,
        icon:'warning'
      });
      warehouse_ref.current.focus()
      return false
    }
    //  if(item_qty < 1){
    //   swal({
    //     title:`Invalid Quantity !`,
    //     icon:'warning'
    //   });
    //   item_qty_ref.current.focus()
    //   return false
    // }




    if( selectedItem.is_serial == 'yes' && selectedGivenSerials.length == 0  ){
      swal({title:'Serial  cart is Empty.',icon:'warning'});return false;
    }

    if( selectedItem.is_serial == 'yes' && selectedGivenSerials.length !=  given_qty  ){
      swal({title:'Serial  & Item quantity   should be same',icon:'warning'});return false;
    }


    let obj = {
      warehouse_id : selectedItemWarehouse != null ? selectedItemWarehouse.warehouse_id :0,
      warehouse_name : selectedItemWarehouse != null ? selectedItemWarehouse.warehouse_name :'',
      item_id : selectedItem.item_id,
      item_name : selectedItem.item_name,
      display_text : selectedItem.display_text,
      is_serial: selectedItem.is_serial,
      item_qty,
      item_rate,
      serials:selectedGivenSerials,
      item_total,
      item_percentage,
      retail_qty,
      given_qty,
      given_rate,
      qty_display: item_qty +' '+ selectedItem.unit_symbol + (conversion >1 ? ', '+ retail_qty +' ' +selectedItem.base_unit_name:''),
      unit_symbol: selectedItem.unit_symbol,
      base_unit_name: selectedItem.base_unit_name,
      unit_name: selectedItem.unit_name,
      conversion: conversion,


      units:givenUnits,
      per_unit_symbol : selectedGivenUnit.unit_symbol,
      per_conversion : selectedGivenUnit.conversion,
      per_unit_id : selectedGivenUnit.unit_id,
   }

   

    let checkExists =   itemGivenCart.findIndex((ele)=>{
        let warehouseId = selectedItemWarehouse == null ? 0 : selectedItemWarehouse.warehouse_id;
        if(ele.item_id==selectedItem.item_id && ele.warehouse_id == warehouseId){ 
          return true 
        }else{
          return false
        }
    }); 

    let tempCart = []

    if(checkExists>-1 && given_ind_id != null){
      let preCopy =  [...itemGivenCart];
      preCopy[given_ind_id] = obj
      itemGivenCartSet(preCopy)
      tempCart = preCopy
    }else{
      itemGivenCartSet([...itemGivenCart,obj])
      tempCart = [...itemGivenCart,obj]

    }


     selectedItemWarehouseSet(null)
     selectedItemSet(null)
     item_qty_set('')
     item_rate_set('')

     given_qty_set(0)
     given_rate_set(0)
     retail_qty_set(0)
     item_percentage_set(0)


     given_ind_id_set(null)

     serialsSet([])
     item_name_set('')



      item_ref.current.focus()

      callAllProductionItem(tempCart)

    }


    useEffect(()=>{
     let rawTotalAmount =  _.sumBy(itemReturnCart,(item)=>Number(item.return_item_total))
         total_cost_set(parseFloat(rawTotalAmount)+parseFloat(labour_cost)+parseFloat(others_cost))
    },[itemReturnCart,labour_cost,others_cost])

    

   

    useEffect(()=>{
      if(selectedReturn != null && selectedReturn.is_serial == 'yes'){
         axios.post(`${API_URL}/api/get-unavailable-serials`,{itemId:selectedReturn.item_id,warehouseId : selectedReturnWarehouse != null ? selectedReturnWarehouse.warehouse_id : 0},{headers:{'auth-token':authInfo.token}}).then((res)=>{
          availableSerialsSet(res.data)
        });
      }
    },[selectedReturn])



    useEffect(()=>{
      if(selectedItem != null && selectedItem.is_serial == 'yes'){
         axios.post(`${API_URL}/api/get-available-serials`,{itemId:selectedItem.item_id,warehouseId : selectedItemWarehouse != null ? selectedItemWarehouse.warehouse_id : 0},{headers:{'auth-token':authInfo.token}}).then((res)=>{
          givenSerialsSet(res.data)
        });
      }
    },[selectedItem])

    // Row add to cart

    const addReturnTOCart = ()=>{

      if(selectedReturn.item_id == 0){
        swal({
          title:`Select Return Item`,
          icon:'warning'
        });
        return_item_ref.current.focus()
        return false
      }

      if(selectedReturn.is_serial == 'yes' && action == 'update' && return_ind_id == null){
        swal({
          title:`Serial Item can't add in Update. You can create new Invoice!`,
          icon:'warning'
        })
        return false
      }

      if(rawItemInfo.current_qty <= 0){
        swal({
          title:`Unavailable Return Item`,
          icon:'warning'
        });
        return false
      }
      
      if(is_warehouse == 'yes' && selectedReturnWarehouse == null){
        swal({
          title:`Select  Warehouse`,
          icon:'warning'
        });
        return_warehouse_ref.current.focus()
        return false
      }
   




      if( rawItemInfo != null && rawItemInfo.current_qty < return_qty ){
        swal({
          title:`Stock is Unavailable !`,
          icon:'warning'
        });
        return false;
      }
  
  
  
  
  
      if( selectedReturn.is_serial == 'yes' && returnSerials.length == 0  ){ 
        swal({title:'Row Serial  cart is Empty.',icon:'warning'});return false;
      }
  
      if( selectedReturn.is_serial == 'yes' && returnSerials.length !=  return_item_qty  ){
        swal({title:'Row Serial  & Row Item quantity   should be same',icon:'warning'});return false;
      }
  
  
      let obj = {
        warehouse_id : selectedReturnWarehouse != null ? selectedReturnWarehouse.warehouse_id :0,
        warehouse_name : selectedReturnWarehouse != null ? selectedReturnWarehouse.warehouse_name :'',
        item_id : selectedReturn.item_id,
        item_name : selectedReturn.item_name,
        display_text : selectedReturn.display_text,
        is_serial: selectedReturn.is_serial,
        return_item_qty,
        return_item_rate,
        serials:returnSerials,
        return_item_total,
  
        return_retail_qty,
        return_qty,
        return_rate,
        qty_display: return_item_qty +' '+ selectedReturn.unit_symbol + (return_conversion >1 ? ', '+ return_retail_qty +' ' +selectedReturn.base_unit_name:''),
        unit_symbol: selectedReturn.unit_symbol,
        base_unit_name: selectedReturn.base_unit_name,
        unit_name: selectedReturn.unit_name,
        return_conversion: return_conversion,

        units:returnUnits,
        per_unit_symbol : selectedReturnUnit.unit_symbol,
        per_conversion : selectedReturnUnit.conversion,
        per_unit_id : selectedReturnUnit.unit_id,
     }
  
     
  
      let checkExists =   itemReturnCart.findIndex((ele)=>{
          let warehouseId = selectedReturnWarehouse == null ? 0 : selectedReturnWarehouse.warehouse_id;
          if(ele.item_id==selectedReturn.item_id && ele.warehouse_id == warehouseId){ 
            return true 
          }else{
            return false
          }
      }); 
  
      if(checkExists>-1 && return_ind_id != null){
        let preCopy =  [...itemReturnCart];
        preCopy[return_ind_id] = obj
        itemReturnCartSet(preCopy)
      }else{
        itemReturnCartSet([...itemReturnCart,obj])
      }
  
  
       selectedReturnWarehouseSet(null)
       selectedReturnSet(null)
       return_item_qty_set(0)
       return_item_rate_set('')
  
       return_qty_set(0)
       return_rate_set(0)
       return_retail_qty_set(0)
  
  
       return_ind_id_set(null)
       
       returnSerialsSet([])
       return_name_set('')
  
  
        return_ref.current.focus()
  
      }
  


    // end 
 

    const editReturnCart = (raw,sl)=>{
  
       return_ind_id_set(sl)
       selectedReturnWarehouseSet({warehouse_id:raw.warehouse_id,warehouse_name:raw.warehouse_name});
       selectedReturnSet({item_id:raw.item_id,item_name:raw.item_name,display_text:raw.display_text,is_serial:raw.is_serial,
        unit_symbol:raw.unit_symbol,base_unit_name:raw.base_unit_name,conversion:raw.return_conversion,base_unit_name:raw.base_unit_name,unit_name:raw.unit_name,
        units: raw.units});
 

console.log(raw)
        selectedReturnUnitSet({unit_symbol : raw.per_unit_symbol,conversion : raw.per_conversion,unit_id : raw.per_unit_id})
per_return_conversion_set(raw.per_conversion)

       returnSerialsSet(raw.serials)
       return_item_qty_set(raw.return_item_qty)
       return_item_rate_set(raw.return_item_rate)
       return_retail_qty_set(raw.return_retail_qty)
       return_qty_set(raw.return_qty)
       return_rate_set(raw.return_rate)
       return_conversion_set(raw.return_conversion)

    }


    const itemReturnCartRemove = (sl,item)=>{
      if(item.is_serial == 'yes' && action == 'update'){
        swal({
          title:`Serial Item can't Remove. You can Delete Invoice!`,
          icon:'warning'
        })
        return false
      }
      let preCopy =  [...itemReturnCart];
      preCopy.splice(sl, 1);
      itemReturnCartSet(preCopy)

    }
  
      // Item cart methods - End

      // Item serial - methods
      const rowSerialAdd = async ()=>{
        if(return_serial_number.trim() == ''){
          swal({
            title:`Row Serial Number is Required.`,
            icon:'warning'
          })
        }else{
         let serialCartCheck =   returnSerials.findIndex((item)=>{
            return item.serial_number == serial_number.trim()
          });
  
          
  
  
          if(serialCartCheck > -1){
            swal({
              title:`Row Serial Number is exists on this serial cart `,
              icon:'warning'
            })
            return false
          }
          
          let itemGivenCartCheck =   itemReturnCart.findIndex((item)=>item.serials.some(s=> s.serial_number == serial_number.trim()));
  
          if(itemGivenCartCheck > -1){
            swal({
              title:`Row Serial Number is exists on Item cart `,
              icon:'warning'
            })
          return false
          }else{
  
            let checkPreviousStock = false;
             await axios.post(`${API_URL}/api/check-serial-number`,{serial_number:serial_number.trim()},{headers:{'auth-token':authInfo.token}}).then((res)=>{
                 if(res.data.error){
                  checkPreviousStock = true
                 }
            });
  
            if(checkPreviousStock){
              swal({
                title:`Serial Number  exists on previous purchase or order`,
                icon:'warning'
              });
              return false;
            }else{
              returnSerialsSet([...serials,{serial_number:serial_number.trim()}])
              return_serial_number_set('');
            }
            
  
          }
          
        }
    }


 

    const rowSerialRemove = (ind)=>{
      let hardCopy =  [...returnSerials];
      hardCopy.splice(ind, 1);
      returnSerialsSet(hardCopy)
    }






    // for item 
    const edititemGivenCart = (raw,sl)=>{
  
      given_ind_id_set(sl)
      selectedItemWarehouseSet({warehouse_id:raw.warehouse_id,warehouse_name:raw.warehouse_name});
      selectedItemSet({item_id:raw.item_id,item_name:raw.item_name,display_text:raw.display_text,is_serial:raw.is_serial,
       unit_symbol:raw.unit_symbol,base_unit_name:raw.base_unit_name,conversion:raw.conversion,base_unit_name:raw.base_unit_name,unit_name:raw.unit_name,
       units: raw.units});

     
      selectedGivenUnitSet({unit_symbol : raw.per_unit_symbol,conversion : raw.per_conversion,unit_id : raw.per_unit_id})
      per_given_conversion_set(raw.per_conversion)

      selectedGivenSerialsSet(raw.serials)
      item_qty_set(raw.item_qty)
      item_rate_set(raw.item_rate)

      item_percentage_set(raw.item_percentage)
     
      retail_qty_set(raw.retail_qty)
      given_qty_set(raw.given_qty)
      given_rate_set(raw.given_rate)
      conversion_set(raw.conversion)

   }


   const itemGivenCartItemRemove = (sl,item)=>{
    if(item.is_serial == 'yes' && action == 'update'){
      swal({
        title:`Serial Item can't Remove. You can Delete Invoice!`,
        icon:'warning'
      })
      return false
    }
     let preCopy =  [...itemGivenCart];
     preCopy.splice(sl, 1);
     itemGivenCartSet(preCopy)
    callAllProductionItem(preCopy);

   }
 
     // Item cart methods - End

     // Item serial - methods
     const serialAdd = async ()=>{
       if(serial_number.trim() == ''){
         swal({
           title:`Serial Number is Required.`,
           icon:'warning'
         })
       }else{
        let serialCartCheck =   serials.findIndex((item)=>{
           return item.serial_number == serial_number.trim()
         });
 
         
 
 
         if(serialCartCheck > -1){
           swal({
             title:`Serial Number is exists on this serial cart `,
             icon:'warning'
           })
           return false
         }
         
         let itemGivenCartCheck =   itemGivenCart.findIndex((item)=>item.serials.some(s=> s.serial_number == serial_number.trim()));
 
         if(itemGivenCartCheck > -1){
           swal({
             title:`Serial Number is exists on Item cart `,
             icon:'warning'
           })
         return false
         }else{
 
           let checkPreviousStock = false;
            await axios.post(`${API_URL}/api/check-serial-number`,{serial_number:serial_number.trim()},{headers:{'auth-token':authInfo.token}}).then((res)=>{
                if(res.data.error){
                 checkPreviousStock = true
                }
           });
 
           if(checkPreviousStock){
             swal({
               title:`Serial Number  exists on previous purchase or order`,
               icon:'warning'
             });
             return false;
           }else{
             serialsSet([...serials,{serial_number:serial_number.trim()}])
             serial_number_set('');
           }
           
 
         }
         
       }
   }


   const serialRemove = (ind)=>{
     let hardCopy =  [...serials];
     hardCopy.splice(ind, 1);
     serialsSet(hardCopy)
   }
      // Item serial methods - end
    
    // Methods  -  End

    // Add Pay To cart
  

  

 

     const options = {
       filterType: 'checkbox',
       selectableRows: 'none',
       display: "excluded"
      }


    return (
    <div className={classes.root}>

     <Paper className={classes.paper} style={{marginTop:'-15px'}}>
    <h2 className={classes.pageEntryLabel}>Product Replace   {pathSpliter(location.pathname,3) == undefined ? 'Entry' :"Update"}  </h2>
      

        
   
    <Grid  container xs={12} sm={12} style={{marginBottom:'10px'}}>
      
      <Grid  item xs={12} sm={3} style={{marginBottom:'10px'}}>

        <Autocomplete 
                   options={customers} 
                   autoHighlight
                   size="small"
                   classes={{
                     option: classes.option,
                   }}
                   getOptionLabel={(option) => option.display_text}
                   value={selectedCustomer}
                   onChange={(event,selectedObj)=>{
                    selectedCustomerSet(selectedObj)
                    if(selectedObj != null){
                      acc_name_set(selectedObj.acc_name)
                      institution_name_set(selectedObj.institution_name)
                      contact_no_set(selectedObj.contact_no)
                      address_set(selectedObj.address)
                    }
                  
                   }}
                   renderInput={(params) => (
                     <TextField
                      
                       onChange={(e)=>customer_name_set(e.target.value)}
                       {...params}
                       label="Search Customer"
                       variant="outlined"
                     
                     />
                   )}

      
  />
      </Grid>
      <Grid  item xs={12} sm={3} style={{marginTop:'-4px',padding:'3px'}}>
        <TextField  autoComplete='off' disabled={selectedCustomer != null && (selectedCustomer.acc_id == 'G' || selectedCustomer.acc_id == 'N') ?"":"true"} className={classes.fullWidth} 
        label="Customer Name" name="acc_name" value={acc_name} 
        onFocus={()=>selectedCustomer != null && (selectedCustomer.acc_id == 'G' || selectedCustomer.acc_id == 'N') && (acc_name.trim() == 'General Customer' || acc_name.trim() == 'New Customer') ? acc_name_set(''):acc_name} 
        onBlur={()=> {
          if(selectedCustomer != null && (selectedCustomer.acc_id == 'G' && acc_name.trim() == '')){
            acc_name_set('General Customer')
           
          }
          if(selectedCustomer != null && (selectedCustomer.acc_id == 'N' && acc_name.trim() == '')){
            acc_name_set('New Customer')
          }
        }} 
        variant="outlined" size="small" onChange={(e)=>acc_name_set(e.target.value)} />
      </Grid>

      <Grid  item xs={12} sm={3} style={{marginTop:'-4px',padding:'3px'}}>
        <TextField  autoComplete='off'  className={classes.fullWidth}
         disabled={selectedCustomer != null && (selectedCustomer.acc_id == 'G' || selectedCustomer.acc_id == 'N') ?"":"true"}
        label="Institution Name" name="institution_name" value={institution_name}  
        variant="outlined" size="small" onChange={(e)=>institution_name_set(e.target.value)} />
      </Grid>

      <Grid  item xs={12} sm={2} style={{marginBottom:'10px'}}>
                    <TextField type="number"  
                   
                  disabled={true}
                    autoComplete='off' className={classes.fullWidth} 
                    label="Current Due" name="previous_due" value={previous_due} 
                    variant="outlined" size="small" onChange={(e)=>{
                      previous_due_set(e.target.value)
                        
                        }} />
                   </Grid>


      <Grid  item xs={12} sm={3} style={{marginTop:'3px',padding:'3px'}}>
        <TextField  autoComplete='off'  className={classes.fullWidth} 
         disabled={selectedCustomer != null && (selectedCustomer.acc_id == 'G' || selectedCustomer.acc_id == 'N') ?"":"true"}
        label="contact No" name="contact_no" value={contact_no} 
        variant="outlined" size="small" onChange={(e)=>contact_no_set(e.target.value)} />
      </Grid>

      <Grid  item xs={12} sm={5}  style={{marginTop:'3px',padding:'3px'}}>
        <TextField  autoComplete='off'  className={classes.fullWidth} 
         disabled={selectedCustomer != null && (selectedCustomer.acc_id == 'G' || selectedCustomer.acc_id == 'N') ?"":"true"}
        label="Customer address" name="address" value={address} 
        variant="outlined" size="small" onChange={(e)=>address_set(e.target.value)} />
      </Grid>

  
  </Grid>
      
      
      <Grid container spacing={2}>
      <Grid  xs={12} sm={4} style={{marginTop: '6px'}}>
      <p style={{fontSize:'14px',margin:'0px',paddin:'0px',textAlign:'left',fontWeight:'bold',padding:'1px',color:'#222',marginBottom:'8px',marginBottom:'8px'}}> Return Items Information</p>


      {
        is_warehouse == 'yes'?(<>

<Grid  item xs={12} sm={12} style={{marginBottom:'10px'}}>
    
      <Autocomplete
              autoHighlight={true}
              openOnFocus={true}
              style={{ width: '100%' }}
              options={warehouses} 
              disabled={action == 'update' ?true:false}
              size="small"
              classes={{
                option: classes.option,
              }}
              getOptionLabel={(option) => option.warehouse_name}
              value={selectedReturnWarehouse}
              onChange={(event,selectedObj)=>{
                selectedReturnWarehouseSet(selectedObj)
              }}
              renderInput={(params) => (
                <TextField
                  inputRef={warehouse_ref}
                  onKeyDown={(e)=>{
                    if(e.key==='Enter'){
                      item_ref.current.focus()
                    }
                  }}
                  {...params}
                  label="Select Warehouse"
                  variant="outlined"
                
                />
              )}
          />
      </Grid>
        
        </>):''
      }
      
      {/* <p style={{fontSize:'10px',margin:'0px',paddin:'0px',textAlign:'left',fontWeight:'bold'}}>Select a Item (By Search)</p> */}
      <Grid  item xs={12} sm={12} style={{marginBottom:'10px'}}>
      
    {
     selectedReturn != null ? <>
       {
          rawItemInfo.current_qty > 0 ?(<p className="stock-availity">Available  : {rawItemInfo.display_qty}</p>)
          :(<p className="stock-unavaility">Unavailable  : {rawItemInfo.display_qty}</p>) 
       }
     </>:''
    }

      <Autocomplete 
          autoHighlight={true}
          openOnFocus={true}
          style={{ width: '100%' }}
          options={rows} 
          size="small" 
          classes={{
            option: classes.option,
          }}
          getOptionLabel={(option) => option.display_text}
          value={selectedReturn}
          onChange={(event,selectedObj)=>{
            selectedReturnSet(selectedObj)
            if(selectedObj != null){
              return_conversion_set(selectedObj.conversion)
            }
            
            return_qty_set('')
            return_retail_qty_set(0)
            return_rate_set('')
          }}
          renderInput={(params) => (
            <TextField
              inputRef={return_ref}
              onKeyDown={(e)=>{
                if(e.key==='Enter'){
                  return_item_qty_ref.current.focus()
                }
              }}
              onChange={(e)=>return_name_set(e.target.value)}
              {...params}
              label="Search Return Item"
              variant="outlined"
            
            />
          )}
          
      />
     
      </Grid>





      {
          selectedReturn != null && selectedReturn.conversion > 1 ?(<>
          
          <Grid  item xs={12} sm={12} style={{marginBottom:'10px'}}>
    
      <Autocomplete
              autoHighlight={true}
              openOnFocus={true}
              style={{ width: '100%' }}
              options={returnUnits} 
              size="small"
              classes={{
                option: classes.option,
              }}
              getOptionLabel={(option) => option.unit_symbol}
              value={selectedReturnUnit}
              onChange={(event,selectedObj)=>{
                selectedReturnUnitSet(selectedObj)
                if(selectedObj != null){
                  per_return_conversion_set(selectedObj.conversion)

                }
              }}
              renderInput={(params) => (
                <TextField
                
                  {...params}
                  label="Per "
                  variant="outlined"
                
                />
              )}
          />
      </Grid>
          </>):''
        }
      {
selectedReturn != null && selectedReturn.is_serial == 'yes'?(<>

<Grid  item xs={12} sm={12} style={{marginBottom:'10px'}}>
      


      <Autocomplete 
          autoHighlight={true}
          openOnFocus={true}
          multiple
          limitTags={10}
          id="multiple-limit-tags" 
          disabled={action == 'update' ?true:false}
          style={{ width: '100%' }}
          options={availableSerials} 
          size="small"
          classes={{
            option: classes.option,
          }}
          getOptionLabel={(option) => option.serial_number}
          value={returnSerials}
          onChange={(event,selectedObj)=>{
            returnSerialsSet(selectedObj)
         
          
          }}
          renderInput={(params) => (
            <TextField
            
              {...params}
              label="Select Return Serials"
              variant="outlined"
            
            />
          )}
          
      />
      </Grid>

</>):''
}


      <p style={{fontSize:'10px',margin:'0px',paddin:'0px',textAlign:'left',fontWeight:'bold',marginBottom:'5px'}}>{
           selectedReturn != null &&  return_conversion > 1  ?  selectedReturn.unit_name :''
          }</p>

      <Grid container xs={12} sm={12} >
      
          
      <Grid item xs={12} sm={5}  style={{marginBottom:'10px'}}>
            <TextField type="number"  
            onBlur={(e)=>e.target.value=='' || e.target.value < 0?return_item_qty_set(0):return_item_qty_set(e.target.value)}
            autoComplete='off' className={classes.fullWidth} 
          label={`QTY ${selectedReturn != null &&  selectedReturn.item_id!=0?'('+selectedReturn.unit_symbol+')':''}`} name="return_item_qty" value={return_item_qty} 
          inputRef={return_item_qty_ref}
          onKeyDown={(e)=>{
            if(e.key==='Enter' ){
              if( return_conversion > 1){
                return_retail_qty_ref.current.focus()
              }else{
                addReturnTOCart()
              }
             
            }
          }}
          variant="outlined" size="small" onChange={(e)=> return_item_qty_set(e.target.value)} />
                
                         
            </Grid>

            <Grid item xs={1} sm={1} ></Grid>
{
  return_conversion > 1 ?(<>
            <Grid item xs={12} sm={6}  style={{marginBottom:'10px'}}>
            <TextField type="number"  
           
            autoComplete='off' className={classes.fullWidth} 
          label={` ${selectedReturn != null ? selectedReturn.base_unit_name:''}  `} name="return_retail_qty" value={return_retail_qty} 
          inputRef={return_retail_qty_ref}
          onBlur={(e)=>e.target.value=='' || e.target.value < 0?return_retail_qty_set(0):return_retail_qty_set(e.target.value)}
          onKeyDown={(e)=>{
            if(e.key==='Enter'){
              addReturnTOCart()
            }
          }}
          variant="outlined" size="small" onChange={(e)=> return_retail_qty_set(e.target.value)} />
                
                         
            </Grid>
  </>):''

}
        


            <Grid item xs={12} sm={6}  style={{marginBottom:'10px'}}>
            <TextField type="number"  
            disabled
            inputRef={return_item_rate_ref}
            onBlur={(e)=>e.target.value=='' || e.target.value < 0?return_item_rate_set(0):return_item_rate_set(e.target.value)}
            onKeyDown={(e)=>{
              if(e.key==='Enter'){
                addReturnTOCart()
              
              }
            }}
           autoComplete='off' className={classes.fullWidth} 
         label="Rate" name="return_item_rate" value={return_item_rate} 
         variant="outlined" size="small" onChange={(e)=>return_item_rate_set(e.target.value)} />
               
                         
            </Grid>

        
       </Grid>
   
   
        
         
         

    

            <Grid item xs={12} sm={12} >
            <TextField type="number"  
           disabled
           autoComplete='off' className={classes.fullWidth} 
         label="Total" name="return_item_total" value={return_item_total} 
         variant="outlined" size="small" onChange={(e)=>return_item_total_set(e.target.value)} />
               
                         
            </Grid>

            

        <span>Press Enter Key to  Cart </span>


        <Grid item xs={12} sm={6} style={{marginTop: '20px'}}>
           <Button onClick={()=>addReturnTOCart()} style={{background: 'rgb(109 113 113)',color: 'white',fontSize: '10px'}}>Add To Cart</Button>
        </Grid>





        <TableContainer >
      <Table className={classes.table} size="small" aria-label="a dense table">
        <TableHead>
              <TableRow>
              <TableCell align="left"   style={{width:'1%'}}>SL</TableCell>
              <TableCell align="left"   style={{width:'15%'}}>Item</TableCell>
              {
                is_serial=='yes'?(<>
              <TableCell align="left"   style={{width:'14%'}}>Serials</TableCell>

                </>):''
              }
              
              {
                is_warehouse == 'yes'?(<>
                  <TableCell align="left"   style={{width:'10%'}}>Warehouse</TableCell>
                </>):''
              }
              <TableCell align="right"  style={{width:'10%'}}>QTY</TableCell>
              <TableCell align="right"  style={{width:'10%'}}>Rate (Per)</TableCell>
            
             
              <TableCell align="right"  style={{width:'10%'}}>Total</TableCell>
              <TableCell align="right"  style={{width:'10%'}}>Actions</TableCell>
            </TableRow>
        </TableHead>
        <TableBody>
              {
                itemReturnCart.map((raw,sl)=>(<>
                   <TableRow key={sl} style={{background: sl == given_ind_id ? '#dedede':'',  transition: '1s'}}>
                  <TableCell align="left">{sl+parseFloat(1)}</TableCell>
                  <TableCell align="left">{raw.item_name}</TableCell>

                  {
                    is_serial == 'yes'?(<>
                     <TableCell align="left">
                      {
                        raw.is_serial == 'yes'?(<>
                            {
                  
                            <>
                            ({raw.serials.map((serial)=>(
                          <> <span>{serial.serial_number}</span>, </> 
                          ))})
                          </>
                            
                              }
                          
                        </>):''
                      }
                  </TableCell>
                    
                    </>):''
                  }
                 {
                   is_warehouse =='yes'?(<>
                          <TableCell align="left">{raw.warehouse_name}</TableCell>
                   </>):''
                 }
                  <TableCell align="right">{raw.qty_display}</TableCell>
                  <TableCell align="right">{format(parseFloat(raw.return_item_rate).toFixed(2))} ({raw.per_unit_symbol})</TableCell>
                 
                
                  <TableCell align="right">{format(parseFloat(raw.return_item_total).toFixed(2))}</TableCell>
                  <TableCell align="right">
                  <EditIcon style={{cursor:'pointer',color:'#2e482e',marginLeft:'2px'}} onClick={()=>{editReturnCart(raw,sl)}}></ EditIcon>
                  <span style={{width:'2px'}}> </span>
                  
                  <RemoveCircleIcon style={{cursor:'pointer',color:'#582727',marginLeft:'2px'}} onClick={()=>{itemReturnCartRemove(sl,raw)}}></ RemoveCircleIcon>
                  </TableCell>
              
                  </TableRow>
                </>))
              }

              {
                itemGivenCart.length > 0 ? (<>
                <TableRow style={{background: 'rgb(249 243 243)',transition: '1s'}}>
                    <TableCell align="right" colSpan={is_serial == 'yes'? (is_warehouse =='yes' ? 5 : 5-1) :(is_warehouse =='yes' ? 4 : 4-1)} style={{fontWeight:'bold'}}>Total  : </TableCell>
                    <TableCell align="right" style={{fontWeight:'bold'}}></TableCell>
                    <TableCell align="right" style={{fontWeight:'bold'}}> {format(parseFloat(_.sumBy(itemReturnCart,(item)=>parseFloat(item.return_item_total))).toFixed(2))}</TableCell>
                 </TableRow>
                </>):''
                 
              }
             
         


     
        </TableBody>
      </Table>
    </TableContainer>






      </Grid>
      <Grid item xs={12} sm={1}></Grid>

      <Grid item xs={12} sm={4}>
   


    
<p style={{fontSize:'14px',margin:'0px',paddin:'0px',textAlign:'left',fontWeight:'bold',padding:'1px',color:'#222',marginBottom:'8px'}}>Given Item cart Information</p>


{
  is_warehouse == 'yes'?(<>

<Grid  item xs={12} sm={12} style={{marginBottom:'10px'}}>

<Autocomplete
        autoHighlight={true}
        openOnFocus={true}
        style={{ width: '100%' }}
        options={warehouses} 
        disabled={action == 'update' ?true:false}

        size="small"
        classes={{
          option: classes.option,
        }}
        getOptionLabel={(option) => option.warehouse_name}
        value={selectedItemWarehouse}
        onChange={(event,selectedObj)=>{
          selectedItemWarehouseSet(selectedObj)
        }}
        renderInput={(params) => (
          <TextField
            inputRef={warehouse_ref}
            onKeyDown={(e)=>{
              if(e.key==='Enter'){
                item_ref.current.focus()
              }
            }}
            {...params}
            label="Select Warehouse"
            variant="outlined"
          
          />
        )}
    />
</Grid>
  
  </>):''
}

{/* <p style={{fontSize:'10px',margin:'0px',paddin:'0px',textAlign:'left',fontWeight:'bold'}}>Select a Item (By Search)</p> */}
<Grid  item xs={12} sm={12} style={{marginBottom:'10px'}}>



<Autocomplete 
    autoHighlight={true}
    openOnFocus={true}
    style={{ width: '100%' }}
    options={items} 
    size="small"
    classes={{
      option: classes.option,
    }}
    getOptionLabel={(option) => option.display_text}
    value={selectedItem}
    onChange={(event,selectedObj)=>{
      selectedItemSet(selectedObj)
      if(selectedObj != null){
        if(itemGivenCart.length == 0){
          item_percentage_set(100)
        }else{
          item_percentage_set(0)
        }
        conversion_set(selectedObj.conversion)
      }
      
      item_qty_set('')
      retail_qty_set(0)
      item_rate_set(0)
    }}
    renderInput={(params) => (
      <TextField
        inputRef={item_ref}
        onKeyDown={(e)=>{
          if(e.key==='Enter'){
            item_qty_ref.current.focus()
          }
        }}
        onChange={(e)=>item_name_set(e.target.value)}
        {...params}
        label="Search Given Item"
        variant="outlined"
      
      />
    )}
    
/>
</Grid>

{
          selectedItem != null && selectedItem.conversion > 1 ?(<>
          
          <Grid  item xs={12} sm={12} style={{marginBottom:'10px'}}>
    
      <Autocomplete
              autoHighlight={true}
              openOnFocus={true}
              style={{ width: '100%' }}
              options={givenUnits} 
              size="small"
              classes={{
                option: classes.option,
              }}
              getOptionLabel={(option) => option.unit_symbol}
              value={selectedGivenUnit}
              onChange={(event,selectedObj)=>{
                selectedGivenUnitSet(selectedObj)
                if(selectedObj != null){
                  per_given_conversion_set(selectedObj.conversion)

                }
              }}
              renderInput={(params) => (
                <TextField
                
                  {...params}
                  label="Per "
                  variant="outlined"
                
                />
              )}
          />
      </Grid>
          </>):''
        }

{
selectedItem  != null && selectedItem.is_serial == 'yes'?(<>

<Grid  item xs={12} sm={12} style={{marginBottom:'10px'}}>
      


      <Autocomplete 
          autoHighlight={true}
          openOnFocus={true}
          multiple
          limitTags={10}
          id="multiple-limit-tags" 
          disabled={action == 'update' ?true:false}
          style={{ width: '100%' }} 
          options={givenSerials} 
          size="small"
          classes={{
            option: classes.option,
          }}
          getOptionLabel={(option) => option.serial_number}
          value={selectedGivenSerials}
          onChange={(event,selectedObj)=>{
            selectedGivenSerialsSet(selectedObj)
         
          
          }}
          renderInput={(params) => (
            <TextField
            
              {...params}
              label="Select Given Serials"
              variant="outlined"
            
            />
          )}
          
      />
      </Grid>

</>):''
}


<p style={{fontSize:'10px',margin:'0px',paddin:'0px',textAlign:'left',fontWeight:'bold',marginBottom:'5px'}}>{
     selectedItem != null &&  conversion > 1  ?  selectedItem.unit_name :''
    }</p>

<Grid container xs={12} sm={12} >

    
<Grid item xs={12} sm={5}  style={{marginBottom:'10px'}}>
      <TextField type="number"  
      onBlur={(e)=>e.target.value=='' || e.target.value < 0?item_qty_set(0):item_qty_set(e.target.value)}
      autoComplete='off' className={classes.fullWidth} 
    label={`QTY ${selectedItem != null &&  selectedItem.item_id!=0?'('+selectedItem.unit_symbol+')':''}`} name="item_qty" value={item_qty} 
    inputRef={item_qty_ref}
    onKeyDown={(e)=>{
      if(e.key==='Enter'){
        if( conversion > 1){
          retail_qty_ref.current.focus()
        }else{
          item_rate_ref.current.focus()
        }
       
      }
    }}
    variant="outlined" size="small" onChange={(e)=> item_qty_set(e.target.value)} />
          
                   
      </Grid>

      <Grid item xs={1} sm={1} ></Grid>
{
conversion > 1 ?(<>
      <Grid item xs={12} sm={6}  style={{marginBottom:'10px'}}>
      <TextField type="number"  
     
      autoComplete='off' className={classes.fullWidth} 
    label={` ${selectedItem != null ? selectedItem.base_unit_name:''}  `} name="retail_qty" value={retail_qty} 
    inputRef={retail_qty_ref}
    onBlur={(e)=>e.target.value=='' || e.target.value < 0?retail_qty_set(0):retail_qty_set(e.target.value)}
    onKeyDown={(e)=>{
      if(e.key==='Enter'){
        item_rate_ref.current.focus()
      }
    }}
    variant="outlined" size="small" onChange={(e)=> retail_qty_set(e.target.value)} />
          
                   
      </Grid>
</>):''

}
  


      <Grid item xs={12} sm={6}  style={{marginBottom:'10px'}}>
      <TextField type="number"  
      inputRef={item_rate_ref}
      onBlur={(e)=>e.target.value=='' || e.target.value < 0?item_rate_set(0):item_rate_set(e.target.value)}
      onKeyDown={(e)=>{
        if(e.key==='Enter'){
          addTOCart()
         
        }
      }}
     autoComplete='off' className={classes.fullWidth} 
     
   label="Rate" name="item_rate" value={item_rate} 
   variant="outlined" size="small" onChange={(e)=>item_rate_set(e.target.value)} />
         
                   
      </Grid>







      <Grid item xs={12} sm={6}  style={{marginBottom:'10px',display:'none'}}>
      <TextField type="number"  
      onBlur={(e)=>e.target.value=='' || e.target.value < 0?item_percentage_set(0):item_percentage_set(e.target.value)}
      onKeyDown={(e)=>{
        if(e.key==='Enter'){
          addTOCart()
        }
      }}
     autoComplete='off' className={classes.fullWidth} 
     
   label="% of Total Costing " name="item_percentage" value={item_percentage} 
   variant="outlined" size="small" onChange={(e)=>item_percentage_set(e.target.value)} />
         
                   
      </Grid>






      

  
 </Grid>


  
   
   



      <Grid item xs={12} sm={12} >
      <TextField type="number"  
     disabled
     autoComplete='off' className={classes.fullWidth} 
   label="Total" name="item_total" value={item_total} 
   variant="outlined" size="small" onChange={(e)=>item_total_set(e.target.value)} />
         
                   
      </Grid>

      

  <span>Press Enter Key to  Cart </span>


  <Grid item xs={12} sm={6} style={{marginTop: '20px'}}>
     <Button onClick={()=>addTOCart()} style={{background: 'rgb(109 113 113)',color: 'white',fontSize: '10px'}}>Add To Cart</Button>
  </Grid>





  <TableContainer >
<Table className={classes.table} size="small" aria-label="a dense table">
  <TableHead>
        <TableRow>
        <TableCell align="left"   style={{width:'1%'}}>SL</TableCell>
        <TableCell align="left"   style={{width:'15%'}}>Item</TableCell>
        {
          is_serial=='yes'?(<>
        <TableCell align="left"   style={{width:'14%'}}>Serials</TableCell>

          </>):''
        }
        
        {
          is_warehouse == 'yes'?(<>
            <TableCell align="left"   style={{width:'10%'}}>Warehouse</TableCell>
          </>):''
        }
        <TableCell align="right"  style={{width:'10%'}}>QTY</TableCell>
        <TableCell align="right"  style={{width:'10%'}}>Rate (Per)</TableCell>
        {/* <TableCell align="right"  style={{width:'10%'}}>% of Costing</TableCell> */}
      
       
        <TableCell align="right"  style={{width:'10%'}}>Total</TableCell>
        <TableCell align="right"  style={{width:'10%'}}>Actions</TableCell>
      </TableRow>
  </TableHead>
  <TableBody>
        {
          itemGivenCart.map((item,sl)=>(<>
             <TableRow key={sl} style={{background: sl == given_ind_id ? '#dedede':'',  transition: '1s'}}>
            <TableCell align="left">{sl+parseFloat(1)}</TableCell>
            <TableCell align="left">{item.item_name}</TableCell>

            {
              is_serial == 'yes'?(<>
               <TableCell align="left">
                {
                  item.is_serial == 'yes'?(<>
                      {
            
                      <>
                      ({item.serials.map((serial)=>(
                    <> <span>{serial.serial_number}</span>, </> 
                    ))})
                    </>
                      
                        }
                    
                  </>):''
                }
            </TableCell>
              
              </>):''
            }
           {
             is_warehouse =='yes'?(<>
                    <TableCell align="left">{item.warehouse_name}</TableCell>
             </>):''
           }
            <TableCell align="right">{item.qty_display}</TableCell>
            <TableCell align="right">{format(parseFloat(item.item_rate).toFixed(2))} ({item.per_unit_symbol})</TableCell>
            {/* <TableCell align="right">{format(parseFloat(item.item_percentage).toFixed(2))}</TableCell> */}
           
          
            <TableCell align="right">{format(parseFloat(item.item_total).toFixed(2))}</TableCell>
            <TableCell align="right">
            <EditIcon style={{cursor:'pointer',color:'#2e482e',marginLeft:'2px'}} onClick={()=>{edititemGivenCart(item,sl)}}></ EditIcon>
            <span style={{width:'2px'}}> </span>
            
            <RemoveCircleIcon style={{cursor:'pointer',color:'#582727',marginLeft:'2px'}} onClick={()=>{itemGivenCartItemRemove(sl,item)}}></ RemoveCircleIcon>
            </TableCell>
        
            </TableRow>
          </>))
        }

        {
          itemGivenCart.length > 0 ? (<>
          <TableRow style={{background: 'rgb(249 243 243)',transition: '1s'}}>
              <TableCell align="right" colSpan={is_serial == 'yes'? (is_warehouse =='yes' ? 5 : 5-1) :(is_warehouse =='yes' ? 4 : 4-1)} style={{fontWeight:'bold'}}>Total  : </TableCell>
              <TableCell align="right" style={{fontWeight:'bold'}}></TableCell>
              <TableCell align="right" style={{fontWeight:'bold'}}> {format(parseFloat(_.sumBy(itemGivenCart,(item)=>parseFloat(item.item_total))).toFixed(2))}</TableCell>
           </TableRow>
          </>):''
           
        }
       
   



  </TableBody>
</Table>
</TableContainer>

  



        </Grid>


        <Grid item xs={12} sm={3} style={{marginTop: '8px',
    padding: '15px'}}>

              <TextField  autoComplete='off' className={classes.fullWidth} 
            
              label="Voucher No" name="voucher_no" value={voucher_no} disabled
              variant="outlined" size="small" onChange={(e)=>voucher_no_set(e.target.value)} />
             

                <LocalizationProvider dateAdapter={AdapterDateFns} style={{marginTop: '8px'}}>
              <Stack spacing={3}>
                <DesktopDatePicker
                 readOnly={authInfo.role == 'user' ? true : false}
                  label="Entry Date" 
                  inputFormat={dateTimeFormat}
                  value={created_date}
                  onChange={(e)=>created_date_set(e)}
                  renderInput={(params) => <TextField {...params} />}
                />
                
              </Stack>
              </LocalizationProvider>
             
               

            <TableContainer  style={{marginTop: '8px'}}>
              <Table className={classes.table} size="small" aria-label="a dense table">
              
              
                
              
             <TableRow > 
             <TableCell><TextareaAutosize 
               
               
               onChange={(e)=>{narration_set(e.target.value)}} value={narration}  name="narration" style={{float:'left',width: '100%'}} aria-label="Narration..." rowsMin={3} placeholder="Narration..." />
             </TableCell>


             <TableCell colSpan={2}></TableCell>

           
          
          </TableRow>
        
      </Table>
    </TableContainer>



    {/* <TextField  style={{marginTop: '8px'}} type="number" autoComplete='off' className={classes.fullWidth} label="Transport Charge" name="labour_cost" 
      onBlur={(e)=>{
        if(e.target.value==''){
          labour_cost_set(0)
        }
      }}
    value={labour_cost} variant="outlined" size="small" onChange={(e)=>labour_cost_set(e.target.value)} /> */}

    
<TextField  style={{marginTop: '8px'}} type="number" autoComplete='off' className={classes.fullWidth} label="Others Charge" name="others_cost" 
  onBlur={(e)=>{
    if(e.target.value==''){
      others_cost_set(0)
    }
  }}
    value={others_cost} variant="outlined" size="small" onChange={(e)=>others_cost_set(e.target.value)} />

<TextField  style={{marginTop: '8px'}} type="number" autoComplete='off' disabled className={classes.fullWidth} label="Total " name="total_cost" 
 onBlur={(e)=>{
  if(e.target.value==''){
    total_cost_set(0)
  }
}}
    value={total_cost} variant="outlined" size="small" onChange={(e)=>total_cost_set(e.target.value)} />


                  <Button  style={{marginTop: '25px',fontSize: '12px'}}
                      variant="contained"
                      color="primary"
                      size="small"
                      disabled={loadingSave}
                      className={classes.button}
                      startIcon={<SaveIcon />}
                      onClick={savePurchaseOrder}
                    >
                      Save 
                    </Button>
          


               <Button 
                  variant="contained"
                  color="primary"
                  size="small"
                  className={classes.button}
                  style={{color: 'white',
                  fontSize:'14px',
                    backgroundColor: '#115f5f',
                    marginTop: '30px'}}
                  disabled={loadingSave}
                  onClick={()=>{
                    window.location.reload();
                    return false;
                  }}
                >
                  Reset
                </Button>
          



          </Grid>

      </Grid>

   
  

     </Paper>











       {/* Switch Branch  Modal */}
   <Modal
        open={serialModal}
        onClose={() => serialModalSet(false)}
        center
        style={{minWidth:'600px !important',minHeight:'500px'}}
 
      
      >
        <h2 style={{margin: 0,
    padding: 0,
    color: '#0f7e77'}}>Serial Number Add of <p style={{fontSize:'10px',margin: 0,
    padding: 0,color:'red'}}>{selectedItem != null ? selectedItem.item_name :''}</p></h2>
        <Grid item xs={12} sm={12} style={{display:'flex',marginTop:'5px',  display: 'flex',
   }} > 
      
        <Grid item  xs={12} sm={10}>
            <TextField label="Serail Number" variant="outlined"  size="small" 
             className={classes.fullWidth} value={serial_number} 
              onChange={(e)=>serial_number_set(e.target.value)}
              name="serial_number" 
             onKeyDown={(e)=>{
                  if(e.key == 'Enter'){
                    serialAdd()
                  }
             }}
              />
          </Grid> 

          <Grid item  xs={12} sm={2}>
              <Button style={{background:'green',fontSize:'20px',
               background: '#03d4be',
    fontSize: '15px'}}
    onClick={()=>serialAdd()}
    >Add</Button> 
          </Grid> 
      
          



         
        </Grid>


        <br/>
          <TableContainer >
      <Table className={classes.table} size="small" aria-label="a dense table">
        <TableHead>
          <TableRow>
            <TableCell align="left">SL</TableCell>
            <TableCell align="left">Serial</TableCell>
            <TableCell align="right">Remove</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>

        
        
        {
            serials.map((serial,ind)=>(
              <TableRow>
              <TableCell align="left">{ind+parseFloat(1)}</TableCell>
              <TableCell align="left">{serial.serial_number}</TableCell>
              <TableCell align="right"  ><span style={{color:'red',fontSize:'18px',cursor:'pointer',margin:0,padding:0}} onClick={()=>serialRemove(ind)}>X</span></TableCell>
            </TableRow>
            ))
          }
        



        </TableBody>
      </Table>
    </TableContainer>



      </Modal>


     

     
    </div>
        
    );
}


 const options = {
   filterType: 'checkbox',
 };
const useStyles = makeStyles((theme) => ({
  button: {
    margin: theme.spacing(1),
    color: 'white',
    fontSize:'10px',
    backgroundColor: '#115f5f'
  },

root: {},
'& .MuiTextField-root': {
  margin: theme.spacing(1),
  width: '25ch',
 },
  paper: {
      padding: theme.spacing(2),
      textAlign: 'center',
      color: theme.palette.text.secondary,
  },
  pageEntryLabel:{
      color: '#240275',
      margin: '0px',
      padding: '0px',
      marginTop: '-11px',
      textAlign: 'left',
      marginLeft: '-8px',
      marginBottom: '5px'
  },
  fullWidth:{
      width:'100%'
  },
  option: {
      fontSize: 15,
      '& > span': {
        marginRight: 10,
        fontSize: 18,
      },
    },
    plusLinkDiv:{
        position:'relative'  
  },
  plusLink:{
    margin: 0,
    padding: 0,
    marginTop: '-21px',
    fontSize: '29px',
    height: '21px',
    textAlign: 'right',
    position: 'absolute',
    right: 0,
    color: '#3e8d54'
  }
}));

const mapStateToPops = (state)=>{
      return {
        currentRoute:state.currentRouteReducer,
        authInfo:state.authInfoReducer
      }
}
export default connect(mapStateToPops,{currentRouteSet})(GroupManage);